import { useMemo, useState } from 'react';

import { findChild, getNext, getPrev } from 'my-core/online-course-content-map';
import { canViewPracticeSection } from 'my-core/online-course-utils';
import { quizQuestionsManagerPath } from 'my-core/routes';
import { hasAnyRoles } from 'my-core/user-utils';

import InCourseExperienceHeader from 'my-components/OnlineCourse/InCourseExperience/InCourseExperienceHeader';
import OnlineCoursePracticeModeSection from 'my-components/OnlineCoursePracticeMode/OnlineCoursePracticeModeSection';
import OnlineCoursePracticeModeWelcome from 'my-components/OnlineCoursePracticeMode/OnlineCoursePracticeModeWelcome';

export default function StudentCoursePagePracticeMode({
  activeComponent,
  basePath,
  classPass,
  courseSubscription,
  currentUser,
  drawerOpen,
  fetchingSubmissions,
  onlineCourseUser,
  onPurchase,
  onToggleDrawer,
  onTokenPurchase,
  sectionSubmissions,
  subscription,
  tokenPurchases,
  tokenPurchaseStatus,
  userCourse,
}) {
  const sectionId = activeComponent?.type === 'section' && activeComponent.data.id;
  const [activeQuestionId, setActiveQuestionId] = useState();

  const nextAndPrev = useMemo(() => {
    if (!(classPass && activeComponent)) return { next: false, prev: false };
    const next = getNext(
      activeComponent,
      n => n.type === 'section' && classPass.practice_mode_section_question_counts?.[n.data.id],
    );
    const prev = getPrev(
      activeComponent,
      n => n.type === 'section' && classPass.practice_mode_section_question_counts?.[n.data.id],
    );
    const pmBasePath = `${basePath}/practice-mode`;
    return {
      next: next && { path: `${pmBasePath}${next.fullPath}`, node: next },
      prev:
        prev ?
          { path: `${pmBasePath}${prev.fullPath}`, node: prev }
        : activeComponent.type === 'section' && {
            path: pmBasePath,
            node: { data: { title: 'Intro' } },
          },
    };
  }, [activeComponent, basePath, classPass]);

  // const learningModePath = sectionId ? practiceModeSectionLearningModePath(classPass, activeComponent) : undefined;
  const learnModeActivity = findChild(activeComponent, n => n.type === 'activity');
  const learnModePath = learnModeActivity && `${basePath}${learnModeActivity.fullPath}`;
  return (
    <>
      <InCourseExperienceHeader
        activeComponent={activeComponent}
        drawerOpen={drawerOpen}
        editPath={
          hasAnyRoles(currentUser, ['admin', 'instructor', 'content_qa_specialist']) && activeQuestionId ?
            quizQuestionsManagerPath({ qq_id: activeQuestionId })
          : undefined
        }
        learnModePath={learnModePath}
        nextAndPrev={nextAndPrev}
        onlineCourse={classPass}
        onToggleDrawer={onToggleDrawer}
      />
      {sectionId ?
        <OnlineCoursePracticeModeSection
          key={sectionId}
          activeSection={sectionId && activeComponent}
          canView={canViewPracticeSection(
            classPass,
            onlineCourseUser,
            subscription,
            userCourse,
            courseSubscription,
            activeComponent,
          )}
          courseSubscription={courseSubscription}
          currentUser={currentUser}
          fetchingSubmissions={fetchingSubmissions}
          learnModePath={learnModePath}
          nextAndPrev={nextAndPrev}
          onlineCourse={classPass}
          onlineCourseUser={onlineCourseUser}
          onPurchase={onPurchase}
          onSetActiveQuestionId={setActiveQuestionId}
          onTokenPurchase={onTokenPurchase}
          sectionId={sectionId}
          sectionSubmissions={sectionSubmissions}
          subscription={subscription}
          tokenPurchases={tokenPurchases}
          tokenPurchaseStatus={tokenPurchaseStatus}
          totalQuestions={classPass.practice_mode_section_question_counts?.[sectionId]}
          userCourse={userCourse}
        />
      : <OnlineCoursePracticeModeWelcome onlineCourse={classPass} />}
    </>
  );
}
